import React from "react";
import NoDataFound from "../shared/NoDataFound";
import { SlIcon } from '@shoelace-style/shoelace/dist/react'
import { Toast } from '../shared/Toast'
import { saveAs } from 'file-saver';
import { toBlob } from 'html-to-image';
import CreativeNameDisplay from "../shared/CreativeNameDisplay";

function NetworkAdPreview({ preview }) {
  const handleClickhdl = async () => {
    if (preview?.hdl) {
      await navigator.clipboard.writeText(preview.hdl)
      Toast('success', "Title Copied")
    }
  };
  const handleClickbdy = async () => {
    if (preview?.bdy) {
      await navigator.clipboard.writeText(preview.bdy)
      Toast('success', "Body Copied")
    }
  };
  const handleDownload = () => {
    const previewElement = document.querySelector('.image-ad');
    toBlob(previewElement).then(function (blob) {
      saveAs(blob, `${preview.hdl}.png`);
    }).catch((error) => console.error(error))

  }
  return (
    <>
      <CreativeNameDisplay preview={preview} />
      <div className="preview-inner" >
        <div className="preview-full-image">
          <div className="h-5/6 flex align-center overflow-hidden">
            <div className="my-auto">
              {preview?.img ? (
                <>
                  <img src={preview.img} alt="" style={{ backgroundColor: 'white' }} className="image-ad" />
                  <div className="download-overlay" ><SlIcon name="download" className="hover:cursor-pointer" onClick={handleDownload} library="lucide"></SlIcon></div>
                </>
              ) : (
                <NoDataFound />
              )}
            </div>

          </div>
          <div className="h-1/6">
            {preview?.hdl ?
              <div className="flex px-2 pt-2 gap-1 mb-0">
                <p className="font-medium ">{preview.hdl}</p>
                <SlIcon name="files" library="lucide" onClick={handleClickhdl} className="hover:cursor-pointer" title="Copy Title"></SlIcon>
              </div> : null}
            {preview?.bdy ? (
              <p className="font-normal px-2">{preview?.bdy?.replace('/$', '$')}{" "}<SlIcon name="files" className="hover:cursor-pointer" library="lucide" title="Copy Body" onClick={handleClickbdy}></SlIcon></p>
            ) : null}
          </div>
        </div>
      </div>

    </>
  );
}

export default NetworkAdPreview;
